import React from 'react';
import Editor from 'draft-js-plugins-editor';
import createBlockBreakoutPlugin from 'draft-js-block-breakout-plugin';
import { createTheming } from 'react-jss';
import { observer } from 'mobx-react';
import InlineToolbar from '../InlineToolbar';
import AtomicToolbar from '../AtomicToolbar';
import createMediaPlugin from '../plugins/media';
import createLinkPlugin from '../plugins/links';
import blockSplittingPlugin from '../plugins/blockSplitting';
import preventBlockDeletion from '../plugins/preventBlockDeletion';
import withStores from '../../stores/withStores';
import defaultAtomicBlockServices from '../AtomicToolbar/services';
import defaultInlineStyleServices from '../InlineToolbar/services';
// export const adaTheme = createTheming('__ADA_EDITOR__');

// const { ThemeProvider: AdaThemeProvider } = adaTheme;

const linkPlugin = createLinkPlugin();
const blockBreakoutPlugin = createBlockBreakoutPlugin();
const mediaPlugin = createMediaPlugin(true);
const preventPlugin = preventBlockDeletion(['title', 'caption', 'media']);
const defaultPlugins = [
  mediaPlugin,
  preventPlugin,
  blockBreakoutPlugin,
  linkPlugin,
  blockSplittingPlugin,
];

@withStores('appStore')
@observer
class AdaEditor extends React.Component {
  render() {
    const {
      page,
      plugins,
      appStore,
      customStyleMap,
      atomicBlockServices,
      inlineStyleServices,
    } = this.props;
    if (!page) return null;
    const readOnly = appStore.editorPaused || !appStore.editMode;
    return (
      <React.Fragment>
        <div key={`${appStore.editMode}-${page.uuid}`}>
          <Editor
            readOnly={readOnly}
            editorKey={`editor-${page.uuid}`}
            plugins={[...defaultPlugins, ...plugins]}
            inlineStyleServices={inlineStyleServices}
            editorState={page.editorState}
            onChange={page.setEditorState}
            pageType={page.type}
            page={page}
            customStyleMap={{
              SUB: {
                position: 'relative',
                top: '0.4em',
                verticalAlign: 'baseline',
              },
              SUPER: {
                position: 'relative',
                top: '-0.4em',
                verticalAlign: 'baseline',
              },
              CODE: {
                fontFamily: '"IBM Plex Mono"',
              },
              ...customStyleMap,
            }}
            appStore={appStore}
          />

          {appStore.editMode && (
            <InlineToolbar
              services={inlineStyleServices}
              editorState={page.editorState}
              setEditorState={page.setEditorState}
            />
          )}
          {appStore.editMode && (
            <AtomicToolbar
              services={atomicBlockServices}
              inlineStyleServices={inlineStyleServices}
              editorState={page.editorState}
              setEditorState={page.setEditorState}
              editorPaused={appStore.editorPaused}
            />
          )}
        </div>
        <div style={{ clear: 'both' }} />
      </React.Fragment>
    );
  }
}

AdaEditor.defaultProps = {
  plugins: [],
  customStyleMap: {},
  atomicBlockServices: defaultAtomicBlockServices,
  inlineStyleServices: defaultInlineStyleServices,
};

export default AdaEditor;
